
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const usePageTitle = (customTitle?: string) => {
  const location = useLocation();
  const [pageTitle, setPageTitle] = useState("Dashboard");
  
  useEffect(() => {
    if (customTitle) {
      setPageTitle(customTitle);
      return;
    }
    
    const path = location.pathname;
    if (path === "/seller/dashboard") setPageTitle("Dashboard");
    else if (path === "/seller/properties/new") setPageTitle("New Property");
    else if (path === "/seller/properties/active") setPageTitle("Active Deals");
    else if (path === "/seller/properties/closed") setPageTitle("Closed Deals");
    else if (path.match(/\/seller\/properties\/.*\/edit/)) setPageTitle("Edit Property");
    else if (path.match(/\/seller\/properties\/.*/)) setPageTitle("Property Details");
    else if (path === "/seller/profile") setPageTitle("My Profile");
    else if (path === "/seller/search-buyers") setPageTitle("Search Buyers");
    else if (path === "/seller/buyer-lists") setPageTitle("My Buyer Lists");
    else if (path.match(/\/seller\/buyer-lists\/.*\/edit/)) setPageTitle("Edit Buyer List");
    else if (path.match(/\/seller\/buyer-lists\/.*/)) setPageTitle("Buyer List Details");
    else if (path === "/seller/deal-tracker") setPageTitle("Deal Tracker");
    else if (path === "/seller/tools") setPageTitle("Tools");
    else if (path === "/seller/tools/repair-estimator") setPageTitle("");
    else if (path === "/seller/tools/profit-calculator") setPageTitle("");
    else if (path === "/buyer/dashboard") setPageTitle("Dashboard");
    else if (path === "/buyer/search") setPageTitle("Search Properties");
    else if (path === "/buyer/saved-properties") setPageTitle("Saved Properties");
    else if (path === "/buyer/profile") setPageTitle("My Profile");
    else if (path === "/buyer/notifications") setPageTitle("Notifications");
    else if (path === "/seller/help") setPageTitle("Help Center");
    else if (path === "/buyer/help") setPageTitle("Help Center");
    else if (path === "/buyer/repair-estimator") setPageTitle("");
    else if (path === "/buyer/profit-calculator") setPageTitle("");
    else setPageTitle("Go Dyspo");
  }, [location, customTitle]);

  return pageTitle;
};
